export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line', description: '热血沸腾的韩国动作漫画，体验刺激冒险' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的韩国奇幻漫画，探索异世界之旅' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的韩国悬疑漫画，烧脑推理佳作' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的韩国喜剧漫画，欢乐不断' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', description: '感人至深的韩国剧情漫画，触动心灵' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的韩国恐怖漫画，胆量挑战' },
  { slug: 'school', name: '校园', icon: 'ri-building-line', description: '青春洋溢的韩国校园漫画，回忆学生时代' },
];